import { ReactNode } from 'react'

interface ProfileSectionProps {
  title: string
  description?: string
  children: ReactNode
}

export function ProfileSection({ title, description, children }: ProfileSectionProps) {
  const sectionStyles: React.CSSProperties = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '1.5rem',
    marginBottom: '1.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  }

  const headerStyles: React.CSSProperties = {
    marginBottom: '1.5rem',
  }

  const titleStyles: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: description ? '0.5rem' : 0,
  }

  const descriptionStyles: React.CSSProperties = {
    fontSize: '14px',
    color: '#6b7280',
  }

  const contentStyles: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  }

  return (
    <section style={sectionStyles}>
      <div style={headerStyles}>
        <h2 style={titleStyles}>{title}</h2>
        {description && <p style={descriptionStyles}>{description}</p>}
      </div>
      <div style={contentStyles}>{children}</div>
    </section>
  )
}
